import { graphql } from '@/gql';
import type { AddSurveyOperatorNoteMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const addSurveyOperatorNote = async ({ id, notes }: AddSurveyOperatorNoteMutationVariables): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation AddSurveyOperatorNote($id: String!, $notes: String!) {
        addSurveyOperatorNote(id: $id, notes: $notes)
      }
    `),
    variables: {
      id,
      notes,
    },
  });

  return response.data?.addSurveyOperatorNote ?? false;
};
